<!-- Header sounds like its on top, but its the sidebar actually -->
<header class="header">
  <app-main-branding />

  <app-main-side-navigation />
</header>
